<template>
  <div class="companyculture">
    <Title :title="title" />
    <div class="container">
      <div class="header">
        <img src="/images/companyculture.jpg" width="100%" alt="">
      </div>
      <div class="flex flex-wrap">
        <div class="content">
          <div class="title">
            <div class="wow fadeInLeft" data-wow-offset="400">
              <img src="/images/Bulb.png" alt="">
              <div>{{$t('about.Corporateculture.title')}}</div>
            </div>
          </div>
          <div class="txt">
            <div class="wow fadeInLeft" data-wow-offset="400" v-html="$t('about.Corporateculture.content')"></div>
          </div>
        </div>
        <div class="img wow fadeInRight" data-wow-offset="400">
          <img src="/images/p3.jpg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '../Title/Title.vue'
export default {
  components: {
    Title
  },
  data() {
    return {
      title: {
        cn: '企业文化',
        en: 'Enterprise Culture'
      }
    }
  }
}
</script>

<style scoped>
.companyculture{
  padding: 50px 0;
}
.companyculture .container{
  max-width: 1500px;
  margin: 0 auto;
  padding: 50px 0;
}
.companyculture .header{
  text-align: center;
}
.companyculture .header img{
  width: 100%;
  display: block;
}
.companyculture .content{
  width: 50%;
  border-right: 1px solid #c6c6c6;
  color: #1e1e1e;
  padding-left: 30px;
}
.companyculture .content .title{
  padding: 30px 0;
  border-bottom: 1px solid #c6c6c6;
  font-size: 25px;
  position: relative;
}
.companyculture .content .title::before,.companyculture .content .title::after{
  content: "";
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #005598;
}
.companyculture .content .title::before{
  top: -4px;
  right: -4px;
}
.companyculture .content .title::after{
  bottom: -4px;
  right: -4px;
}
.companyculture .content .txt{
  font-size: 14px;
  line-height: 40px;
  padding: 30px 30px 30px 0;
  position: relative;
}
.companyculture .content .txt::before{
  content: "";
  position: absolute;
  top: -7px;
  right: -7px;
  width: 11px;
  height: 11px;
  border: 1px solid #005598;
  border-radius: 50%;
}
.companyculture .img{
  padding: 50px 0 0 50px;
  width: 50%;
}
.companyculture .img img{
  width: 100%;
}
@media (max-width: 768px){
  .companyculture .content{
    width: 100%;
    border-right: 0;
    padding: 0 20px;
  }
  .companyculture .img{
    width: 100%;
    padding: 0;
  }
  .companyculture .content .title::before,
  .companyculture .content .title::after,
  .companyculture .content .txt::before{
    display: none;
  }
  .companyculture .content .txt{
    padding-right: 0;
  }
}
</style>


